export const GO_TO_FORGOT_PASSWORD = 'GO_TO_FORGOT_PASSWORD';
export const REQUEST_PASSWORD_RESET = 'REQUEST_PASSWORD_RESET';
export const PROCESS_PASSWORD_RESET = 'PROCESS_PASSWORD_RESET';

const STORE_USER_EMAIL = 'STORE_USER_EMAIL';

export const LOAD_PASSWORD_MODE = 'LOAD_PASSWORD_MODE';
const STORE_PASSWORD_MODE = 'STORE_PASSWORD_MODE';

const initialPasswordChangeState = {
  userEmail: '',
  passwordMode: ''
};

export const passwordChangeReducer = (passwordChangeState = initialPasswordChangeState, action = null) => {
  switch (action && action.type) {
    case GO_TO_FORGOT_PASSWORD:
    case LOAD_PASSWORD_MODE:
      return passwordChangeState;

    case STORE_USER_EMAIL:
      return {
        ...passwordChangeState,
        userEmail: action.payload.userEmail
      };

    case STORE_PASSWORD_MODE:
      return {
        ...passwordChangeState,
        passwordMode: action.payload
      };

    case REQUEST_PASSWORD_RESET:
      return passwordChangeState;

    case PROCESS_PASSWORD_RESET:
      return passwordChangeState;

    default:
      return passwordChangeState;
  }
};

export const passwordChangeActions = {
  goToForgotPassword: (userEmail) => ({ type: GO_TO_FORGOT_PASSWORD, payload: { userEmail } }),
  storeUserEmail: (userEmail) => ({ type: STORE_USER_EMAIL, payload: { userEmail } }),
  loadPasswordMode: ({ userId, resetPasswordId }) => ({
    type: LOAD_PASSWORD_MODE,
    payload: { userId: userId, resetPasswordId: resetPasswordId }
  }),
  storePasswordMode: (passwordMode) => ({ type: STORE_PASSWORD_MODE, payload: passwordMode }),
  requestPasswordReset: (userEmail) => ({ type: REQUEST_PASSWORD_RESET, payload: { userEmail } }),
  processPasswordReset: (resetRequestUuid, newPassword) => ({
    type: PROCESS_PASSWORD_RESET,
    payload: {
      resetRequestUuid: resetRequestUuid,
      newPassword: newPassword
    }
  })
};

export const passwordChangeSelectors = {
  getUserEmail: (state) => state.passwordChange.userEmail,
  // getPasswordMode returns either 'strict' or 'simple'
  getPasswordMode: (state) => state.passwordChange.passwordMode
};



// WEBPACK FOOTER //
// ./src/modules/login/reducer/password-change-reducer.js